import { GET, POST } from '../request'

export const getAccesoClassfy = cliente =>
  GET('/api/agora/classfy/acceso-classfy', { cliente })

export const createAccesoClassfy = ({ cliente, email }) =>
  POST('/api/agora/classfy/acceso-classfy', { cliente, email })

export const getAsistenciasClassfy = ({ alumno, mes }) =>
  GET('/api/agora/classfy/asistencia-classfy/list', { alumno, mes })
